import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import {HashLink} from 'react-router-hash-link';
import {Button} from "./Button";
import "./NavBar.css";

function NavBar(props) {
	const [click, setClick] = useState(false);
	const [button, setButton] = useState(true);

	useEffect(() => {
		showButton();
	}, []);

	const handleClick = () => setClick(!click);
	const closeMobileMenu = () => setClick(false);

	const showButton = () => {
		if (window.innerWidth <= 960) {
			setButton(false);
		} else {
			setButton(true);
		}
	}

	window.addEventListener("resize", showButton);
	window.addEventListener("", showButton);

	return (
		<>
			<nav className="navbar">
				<div className="navbar-container">
					<HashLink smooth to="/#home" className="navbar-logo" onClick={closeMobileMenu}>
						e23.cz
						<p className="iweb-logo"/>
					</HashLink>
					<div className="menu-icon" onClick={handleClick}>
						<i className={click ? "fas fa-times" : "fas fa-bars"} />
					</div>
					<ul className={click ? "nav-menu active" : "nav-menu"} >
						<li className="li nav-item">
							<HashLink smooth to="/#home" className="nav-links" onClick={closeMobileMenu}>
								Úvod
							</HashLink>
						</li>
						<li>
							<HashLink smooth to="/#poradenstvi" className="nav-links" onClick={closeMobileMenu}>
								Poradenství
							</HashLink>
						</li>
						<li>
							<HashLink smooth to="/#vyvoj" className="nav-links" onClick={closeMobileMenu}>
								Vývoj
							</HashLink>
						</li>
						<li>
							<HashLink smooth to="/#servis" className="nav-links" onClick={closeMobileMenu}>
								Servis
							</HashLink>
						</li>
						<li>
							<HashLink smooth to="/#prodej" className="nav-links" onClick={closeMobileMenu}>
								Prodej
							</HashLink>
						</li>
						<li>
							<Link to="/kontakt" className="nav-links-mobile" onClick={closeMobileMenu}>
								Kontakt
							</Link>
						</li>
					</ul>
					{button && <Button buttonStyle="btn--outline">KONTAKT</Button>}
				</div>
			</nav>

		</>
	);
}

export default NavBar;